import { render, staticRenderFns } from "./Mjurisdict.vue?vue&type=template&id=5d301c81&scoped=true"
import script from "./Mjurisdict.vue?vue&type=script&lang=js"
export * from "./Mjurisdict.vue?vue&type=script&lang=js"
import style0 from "./Mjurisdict.vue?vue&type=style&index=0&id=5d301c81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d301c81",
  null
  
)

export default component.exports